window.disableAppMediaAccess = false;

const patchMediaDevices = () => {
  if (!navigator.mediaDevices?.getUserMedia) {
    console.warn('navigator.mediaDevices.getUserMedia does not exist');
    return;
  }

  // Prevent double-patching
  if (navigator.mediaDevices.getUserMedia.__isPatched) {
    return;
  }

  const originalGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

  navigator.mediaDevices.getUserMedia = async (...args) => {
    if (window.disableAppMediaAccess) {
      console.log("Media access blocked: User is in guest/readonly mode.");
      return new MediaStream(); // Return an empty stream to avoid breaking app logic that expects a stream
    }
    return originalGetUserMedia(...args);
  };

  navigator.mediaDevices.getUserMedia.__isPatched = true;

  console.log("Media devices API patched.");
};

try {
  // Initialize the patch immediately when the app loads
  patchMediaDevices();
}
catch (err) {
  console.warn('error patching navigator.mediaDevices.getUserMedia to prevent requesting audio/video stream permissions when logged in as guest (readonly mode, no streaming allowed)', err);
}
